import React from 'react';

const SmileyCar = ({ width, height }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
  >
    <ellipse
      cx="54.6987"
      cy="24.8945"
      rx="12"
      ry="3"
      stroke="#00AED9"
      strokeWidth="2"
    />
    <path
      d="M67.6987 76.8945C65.3557 79.8651 60.6375 81.8945 55.1987 81.8945C49.7599 81.8945 45.0417 79.8651 42.6987 76.8945"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M62 62C62 62 53.6626 62 48 62M35 62H23.8559C23.3832 62 23 61.6168 23 61.1441V58.3895V58M23 58H11M23 58C23 58 23 56.3905 23 56M14 52.0609H23V49.3989C23 48.9056 23.3597 48.486 23.8472 48.4107L34.6444 46.7417C34.7918 46.7189 34.9307 46.6579 35.0473 46.5649L37.6543 44.4855L38.3505 43.9302M75 62H88.1441C88.6168 62 89 61.6168 89 61.1441V53.7564C89 53.009 88.5151 52.348 87.8022 52.1235L76.5903 48.5936C76.4813 48.5593 76.3803 48.5035 76.2932 48.4295L64.2569 38.2036C64.1021 38.0722 63.9057 38 63.7027 38H46.281C46.0985 38 45.9207 38.0584 45.7737 38.1666L43.2241 40.0429L42.0507 40.8494C41.908 40.9475 41.739 41 41.5659 41H31"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="41.7261" cy="62.4268" r="6" stroke="#00619E" strokeWidth="2" />
    <circle cx="68.3062" cy="62.4268" r="6" stroke="#00619E" strokeWidth="2" />
    <path
      d="M66.2212 74.1558C66.5129 75.4483 67.8837 77.8464 71.0325 77.0989"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M9.69873 51.8945H6.69873"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M26.6987 40.8945H20.6987"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export default SmileyCar;
